.image {
  height: 3rem;
  width: 5rem;
  object-fit: cover;
}

.fileName {
  word-break: break-word;
}

.flaggedItem {
  border-left: var(--size-border-md) solid var(--color-brand-danger-500) !important;
}
